<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :show-close="false"
    center
    width="40%"
  >
    <dialog-header
      slot="title"
      :title="!isEdit? $t('system.maintenance.create'):$t('system.maintenance.update')"
      :icon="!isEdit? 'icon-dialog-add':'icon-dialog-update'"
      @close="closeDialog"
    />
    <vue-linetitle style="padding-top:10px">
      <el-row :gutter="10" type="flex" justify="center" align="top">
        <el-col :span="24">
          <el-form ref="form" size="mini" :model="formInfo" :rules="rules"
            label-suffix="："
            label-width="auto">
            <el-form-item :label="$t('system.maintenance.itemName')" prop="itemName">
              <el-input v-model="formInfo.itemName" :maxlength="50"  :placeholder="$t('system.maintenance.itemName')" clearable  />
            </el-form-item>
            <el-form-item :label="$t('system.maintenance.itemNameEn')" prop="itemNameEn">
              <el-input v-model="formInfo.itemNameEn" :maxlength="50" :placeholder="$t('system.maintenance.itemNameEn')" clearable  />
            </el-form-item>

            <el-form-item :label="$t('system.maintenance.itemType')" prop="itemType">
              <el-select
                v-model="formInfo.itemType"
                :placeholder="$t('system.maintenance.itemType')"
                filterable
                clearable
              >
                <el-option
                  v-for="(item,index) in searchContent"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </vue-linetitle>
    <div style="height:8px"></div>
    <span slot="footer" class="dialog-footer">
      <el-button v-waves class="dialog-cancel" type="primary" @click="handlecancle">{{$t('public.cancel')}}</el-button>
      <el-button v-waves type="primary" @click="handleSubmit">{{$t('public.define')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
// request
import { createMaintenance, updateMaintenance } from '@/api/system/maintenanceManage'
// 混入
import { partialForm } from '@/mixins/partialForm'
export default {
  name: 'AddUpdateDialog',
  // components: { appOrganizePicker },
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    token() {
      return this.$store.getters.token
    }
  },
  data() {
    // 项目名称
    const itemName = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('system.maintenance.msg.error1')))
      }
    }
    // 项目英文名称
    const itemNameEn = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('system.maintenance.msg.error2')))
      }
    }
    //项目分组
    const itemType = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('system.maintenance.msg.error3')))
      }
    }
 
    // 手机号验证
    // const mobile = (rule, value, cb) => {
    //   if (!value) {
    //     return cb(new Error(this.$t('输入手机号')))
    //   }
    // }
    return {
      searchContent:[],
      searchContent1: [
        { label: this.$t('system.maintenance.searchName.first'), value: 1 },
        { label: this.$t('system.maintenance.searchName.second'), value: 2 },
        { label: this.$t('system.maintenance.searchName.third'), value: 3 },
       ],
       searchContent2: [
        { label: this.$t('system.maintenance.searchName.custom'), value: 4 },
       ],
      defaultFormInfo: {
        isDisabled: 0
      },
      formInfo: {},
      rules: {
        itemName: [
          { required: true, trigger: ['blur','change'], validator: itemName }
        ],
        itemNameEn: [
          { required: true, trigger: ['blur','change'], validator: itemNameEn }
        ],
        itemType: [
          { required: true, trigger: ['blur','change'], validator: itemType }
        ]
        // mobile: [
        //   { required: true, trigger:['blur','change'], validator: mobile }
        // ]
      }
    }
  },
  watch: {
    visibles: {
      handler(e1) {
        if (e1) {
          this.searchContent.length ===0 
          // console.log(this.$store.state.user.userInfo.roles[0].weight)
          if(this.$store.state.user.userInfo.roles[0].weight == 200){
            this.searchContent = this.searchContent1
          }else{
            this.searchContent = this.searchContent2
          }
          this.formInfo = { ...this.defaultFormInfo, ...this.data }
          
        }
      }
    }
  },

  methods: {

    // 关闭dialog
    closeDialog() {
      this.formInfo = {...this.defaultFormInfo}
      this.$emit('update:visibles', false)
    },
    // 点击取消
    handlecancle() {
      this.closeDialog()
    },
    // 点击确定
    handleSubmit(){
      let check = this.checkForm({ formName: 'form',
          formList: ['itemName','itemNameEn','itemType'] })
      if(!check) return
      // eslint-disable-next-line no-unused-vars
      const { itemId, createdOn,...postData } = this.formInfo
      if(!this.isEdit){
        this._createMaintenance(postData)
      }else{
        this._updateMaintenance({data: postData, id: itemId})
      }
          
    },
  
    // 新增
    _createMaintenance(postData) {
      createMaintenance(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    // 编辑
    _updateMaintenance(postData) {
      updateMaintenance(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    }
  }
}
</script>
